import React, {useState, useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Title from "../dashboard/Title";
import Button from "@material-ui/core/Button";
import SelectInput from "./input/SelectInput";
import UserService from "../../services/user.service";
import {logOut} from "../../helpers/logout";
import {Redirect, useParams} from "react-router-dom";
import {NotificationManager} from 'react-notifications';
import Paper from "@material-ui/core/Paper";
import TextInput from "./input/TextInput";
import {InputAdornment, TextField, Checkbox, FormControlLabel} from "@material-ui/core";
import SelectInputAdjusted from "./input/SelectInputAdjusted";
import {useDashboardStyles, BRAND} from "../settings/dashboardStyles";

const useLocalStyles = makeStyles((theme) => ({
    fieldRow: {
        marginBottom: theme.spacing(2.5),
        paddingBottom: theme.spacing(1.5),
        borderBottom: `1px solid rgba(176, 141, 87, 0.10)`,
        "&:last-child": {
            borderBottom: "none",
            marginBottom: 0,
            paddingBottom: 0,
        },
    },
    invoiceRow: {
        marginTop: theme.spacing(1),
        padding: theme.spacing(1.5, 2),
        background: BRAND.creamSoft,
        border: `1px solid ${BRAND.goldSoft}`,
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        flexWrap: "wrap",
    },
    invoicePrice: {
        minWidth: 160,
    },
    disabledField: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1.5, 2),
        background: "rgba(244, 67, 54, 0.04)",
        border: "1px dashed rgba(244, 67, 54, 0.30)",
        borderRadius: 8,
        color: BRAND.inkSoft,
        fontSize: "0.9rem",
    },
    formActionsBar: {
        marginTop: theme.spacing(3),
        display: "flex",
        gap: theme.spacing(1.5),
        justifyContent: "flex-end",
        flexWrap: "wrap",
        [theme.breakpoints.down("xs")]: {
            "& > button": {
                flex: "1 1 auto",
            },
        },
    },
}));

export default function ServicesForm(props) {
    const classes = useDashboardStyles();
    const localClasses = useLocalStyles();

    const [entities, setEntities] = useState([]);
    const [success, setSuccess] = useState(false);
    const [user, setUser] = useState(null);


    const handleTextInput = index => e => {
        let newArr = [...entities];
        newArr[index].text = e.target.value;
        setEntities(newArr);
    }

    const handleNumberInput = index => e => {
        let newArr = [...entities];
        newArr[index].number = e.target.value;
        setEntities(newArr);
    }

    const handleYesNoInput = index => e => {
        let newArr = [...entities];
        newArr[index].yes_no = e.target.value;
        setEntities(newArr);
    }

    const handleTextCostInput = index => e => {
        let newArr = [...entities];
        newArr[index].text_cost = e.target.value;
        setEntities(newArr);
    }

    const handleInvoicePriceInput = index => e => {
        let newArr = [...entities];
        newArr[index].invoice_price = parseFloat(e.target.value) || 0;
        setEntities(newArr);
    }

    const handleShowInvoiceCheckbox = index => e => {
        let newArr = [...entities];
        newArr[index].show_invoice = e.target.checked;

        if (e.target.checked && newArr[index].service_template?.type === 4 && newArr[index].text_cost?.cost) {
            newArr[index].invoice_price = parseFloat(newArr[index].text_cost.cost);
        }

        setEntities(newArr);
    }

    const params = useParams();
    const user_local = JSON.parse(localStorage.getItem('user')).id;

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
            },
            (e) => {
                if (e.response?.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );

        UserService.getFuneral(props.match.params.funeral_id).then(
            (response) => {
                let ents = response.data.service_entities.map(entity => {
                    if (!entity.service_template) {
                        return entity;
                    }
                    if (entity.service_template.type === 4) {
                        entity.service_template.text_cost_option = entity.service_template.text_cost_option.map(val => {
                            return {text: val.text, cost: val.cost}
                        });
                    }
                    return entity;
                })
                setEntities(ents);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [props, user_local]);

    const handleUpdate = (e) => {
        e.preventDefault();

        UserService.updateServiceEntities(entities).then(
            () => {
                setSuccess(true);
                NotificationManager.success('Dáta o službách upravené.', 'Upravené', 5000);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                } else {
                    NotificationManager.error('Došlo k neočakávanej chybe. Skúste neskôr alebo kontaktujte podporu.', 'Chyba', 5000);
                }
            }
        );
    };

    return (
        <form onSubmit={handleUpdate}>
            <Container maxWidth="lg" className={classes.pageContainer}>
                <Paper className={classes.paper} elevation={0}>
                    <div className={classes.sectionHeader}>
                        <Title>Úprava hodnôt služieb</Title>
                    </div>

                    {entities.length === 0 && (
                        <div className={classes.emptyState}>
                            K tomuto pohrebu nie sú priradené žiadne služby.
                        </div>
                    )}

                    {entities.map((item, index) => {
                        if (!item.service_template) {
                            return (
                                <div key={index} className={localClasses.disabledField}>
                                    <strong>{item.name}:</strong> Hodnota nemenná. Šablóna bola vymazaná.
                                </div>
                            );
                        }

                        let mainField;
                        switch (item.service_template.type) {
                            case 0:
                                mainField = <TextInput
                                    label={item.name}
                                    type={'text'}
                                    value={entities[index].text ? entities[index].text : ''}
                                    onChange={handleTextInput(index)}
                                    fullWidth
                                />
                                break;
                            case 1:
                                mainField = <SelectInput
                                    label={item.name}
                                    value={entities[index].text ? entities[index].text : ''}
                                    options={item.service_template.text_option.map((opt) => ({value: opt, title: opt}))}
                                    onChange={handleTextInput(index)}
                                    fullWidth
                                />
                                break;
                            case 2:
                                mainField = <SelectInput
                                    label={item.name}
                                    value={entities[index].yes_no !== undefined ? entities[index].yes_no : ''}
                                    options={[{value: true, title: 'Áno'}, {value: false, title: 'Nie'}]}
                                    onChange={handleYesNoInput(index)}
                                    fullWidth
                                />
                                break;
                            case 3:
                                mainField = <TextInput
                                    label={item.name}
                                    type={"number"}
                                    value={entities[index].number ? entities[index].number : ''}
                                    onChange={handleNumberInput(index)}
                                    fullWidth
                                />
                                break;
                            default:
                                mainField = <SelectInputAdjusted
                                    label={item.name}
                                    name={'select'}
                                    value={entities[index].text_cost ? entities[index].text_cost : ''}
                                    options={item.service_template.text_cost_option}
                                    onChange={handleTextCostInput(index)}
                                    fullWidth
                                />
                        }

                        return (
                            <div key={index} className={localClasses.fieldRow}>
                                {mainField}
                                {user && user.iban && (
                                    <div className={localClasses.invoiceRow}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={entities[index].show_invoice || false}
                                                    onChange={handleShowInvoiceCheckbox(index)}
                                                    color="primary"
                                                    size="small"
                                                />
                                            }
                                            label={<span style={{fontSize: '0.9rem', fontWeight: 500}}>Pridať do faktúry</span>}
                                        />
                                        {entities[index].show_invoice && (
                                            <div className={localClasses.invoicePrice}>
                                                <TextInput
                                                    label="Cena"
                                                    type="number"
                                                    value={entities[index].invoice_price ? entities[index].invoice_price : ''}
                                                    onChange={handleInvoicePriceInput(index)}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                                    }}
                                                    fullWidth
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </Paper>

                <div className={localClasses.formActionsBar}>
                    <Button
                        className={classes.secondaryAction}
                        onClick={() => setSuccess(true)}
                    >
                        Späť na detaily
                    </Button>
                    <Button
                        type='submit'
                        className={classes.primaryAction}
                    >
                        Uložiť zmeny
                    </Button>
                </div>
            </Container>
            {success ? <Redirect to={{
                pathname: `/pohreb/${params.funeral_id}/info`,
                state: {from: props.location, number: 2}
            }}/> : <></>}
        </form>
    );
}
